module.exports = __webpack_public_path__ + "static/media/logout.fd03615c.svg";